import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { CustomDataGrid } from 'components/datagrid/Custom';
import { useEffect } from 'react';
import { DataGridKey } from 'redux/slices/datagrid';
import { PATH_DASHBOARD } from 'routes/paths';
import { useNavigate } from 'react-router';
import useCustomDispatch, { useCustomDispatchWithoutPromise } from 'redux/dispatch';
import { RootState, useSelector } from 'redux/store';
import { getOrders, resetOrders } from 'redux/slices/orders';
import { IntegrationLogo } from 'pages/integrationStore/components/IntegrationLogo';
import { Integration, ProductCategory } from '../../../../@types/integrations';
import { getBaseOrderColumns, baseOrderInitialColumnsHidden } from '../baseOrder/baseOrderColumns';
import { useTranslator } from 'translation/useTranslator';
import { Box } from '@mui/material';

export default function ProductOrderList() {
  const translator = useTranslator();
  const navigate = useNavigate();
  const customDispatch = useCustomDispatch();
  const customDispatchWithoutPromise = useCustomDispatchWithoutPromise();
  const { isLoading, orderData } = useSelector((state: RootState) => state.order);
  useEffect(() => {
    (async () => {
      await customDispatch({
        action: getOrders,
        actionParameters: { endpoint: 'product-orders' },
        disableSuccessMessage: true
      });
    })();
    return () => {
      customDispatchWithoutPromise({
        action: resetOrders,
        disableAllMessages: true
      });
    };
  }, [customDispatch, customDispatchWithoutPromise]);

  const columns: GridColDef<any>[] = [
    {
      field: 'integration',
      headerName: translator.product(),
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <Box display={'flex'} justifyContent={'space-between'} flex={1} alignItems={'center'}>
            {params.row.integration?.name}
            <IntegrationLogo integration={params.row.integration as Integration} />
          </Box>
        );
      }
    },
    {
      field: 'integration/productCategory',
      headerName: translator.type(),
      flex: 1,
      valueGetter: (_value, row) => row.integration?.productCategory as ProductCategory,
      renderCell: (params: GridRenderCellParams<any>) => {
        return ProductCategory[params.row.integration?.productCategory as ProductCategory];
      }
    },
    {
      field: 'amount',
      headerName: translator.amount(),
      flex: 1,
      type: 'number'
    },
    ...getBaseOrderColumns(translator)
  ];
  return (
    <CustomDataGrid
      intitialColumnsHidden={{
        integration: true,
        ...baseOrderInitialColumnsHidden
      }}
      dataGridKey={DataGridKey.Orders}
      columns={columns}
      loading={isLoading}
      rows={orderData.orders}
      onCellClick={(params) => {
        navigate(`${PATH_DASHBOARD.productOrders.productOrders}/${params.id}`);
      }}
      pagination
      paginationModel={{ page: 0, pageSize: 20 }}
      pageSizeOptions={[20]}
    />
  );
}
